import { z } from 'zod'

import { PASSWORD_VALIDATION } from '@/constants/common.constants'
import { FORM_MESSAGES_MAP } from '@/constants/formMessages.constants'

export const registerFormSchema = z
  .object({
    agreeToPrivacyPolicy: z.boolean().refine(val => val === true, {
      message: FORM_MESSAGES_MAP.PRIVACY_POLICY,
    }),
    agreeToTerms: z.boolean().refine(val => val === true, {
      message: FORM_MESSAGES_MAP.TERMS,
    }),
    confirmPassword: z.string().min(1),
    email: z.string().min(1).email(),
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    password: z.string().min(1).regex(PASSWORD_VALIDATION, {
      message: FORM_MESSAGES_MAP.PASSWORD,
    }),
  })
  .superRefine(({ confirmPassword, password }, ctx) => {
    if (confirmPassword !== password) {
      ctx.addIssue({
        code: 'custom',
        message: FORM_MESSAGES_MAP.CONFIRM_PASSWORD,
        path: ['confirmPassword'],
      })
    }
  })
